export default {
  en: {
    MONHTLY_BILLING: 'Monthly Billing',
    BILLING_MONTHS_TABLE_EMPTY: 'No billable months yet',
    BILLING_MONTHS_TABLE_LOADING: 'Loading billable months',
    REFERENCE_PERIOD: 'Period',
    TRANSACTION_HISTORY_RECEIPT: 'Receipt',
    INVOICE: 'Statement',
    DOWNLOAD_INVOICE_MONTH: 'Download the billing statement for the selected month.',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_HEADER: 'Recharge Settings',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_AMOUNT_DEFAULT: 'Select Amount',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_AMOUNT_TT: 'The amount you would like us to automatically recharge your account with when it falls below the limit.',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_AMOUNT: 'Recharge Amount',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_BELOW_DEFAULT: 'Select Amount',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_BELOW_TT: 'Once your balance falls below this amount, we will recharge your account.',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_BELOW: 'Recharge Below',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_SUCCESS: 'Recharge settings updated.',
    ACCOUNT_BILLING_SETTINGS_RECHARGE_TT: 'When your balance falls below the selected balance we\'ll automatically refill your account to prevent any service interruption.',
    ACCOUNT_BILLING_SETTINGS_RECHARGE: 'Auto Recharge',
    ACCOUNT_BALANCE: 'Account Balance',
    ACCOUNT_BILLING_ADD_FUNDS_SUCCESS: 'Funds added to your account.',
    ACCOUNT_BILLING_BALANCE_ADD_BUTTON: 'Add Funds',
    ACCOUNT_BILLING_BALANCE_CURRENT_TT: 'The current amount of credit in your Ringba account.',
    ACCOUNT_BILLING_BALANCE_CURRENT: 'Balance',
    ACCOUNT_BILLING_ADD_FUNDS_HEADER: 'Add Funds',
    ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD_DEFAULT: 'Select',
    ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD_TT: 'Please select which of your credit cards you would like to bill.',
    ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD: 'Card to Bill',
    ACCOUNT_BILLING_ADD_FUNDS_SELECT_CARD_PLACEHOLDER: 'Select Credit Card',
    ACCOUNT_BILLING_ADD_FUNDS_CURRENT_BALANCE_TT: 'Your current account balance.',
    ACCOUNT_BILLING_ADD_FUNDS_CURRENT_BALANCE: 'Current Balance',
    ACCOUNT_BILLING_ADD_FUNDS_AMOUNT_TT: 'The amount of funds you\'d like to add to your account.',
    ACCOUNT_BILLING_ADD_FUNDS_AMOUNT: 'Amount',
    ACCOUNT_BILLING_INVALID_AMOUNT: 'Min: $25, Max: $10,000',
    ACCOUNT_BILLING_HISTORY_HEADER: 'Transaction History',
    ACCOUNT_BILLING_HISTORY_AMOUNT: 'Amount',
    ACCOUNT_BILLING_HISTORY_DATE: 'Date',
    ACCOUNT_BILLING_HISTORY_DESCRIPTION: 'Description',
    ACCOUNT_BILLING_HISTORY_INVOICE_TT: 'Download receipt',
    ACCOUNT_BILLING_HISTORY_NUMBER: 'Card Number',
    ACCOUNT_BILLING_HISTORY_TYPE: 'Type',
    TRANSACTION_HISTORY_EMPTY: 'There are no transactions to display.',
    TRANSACTION_HISTORY_ERROR: 'Error Loading Transaction History','ACCOUNT_BILLING_ADD_CC_ADDRESS_TT': 'Enter a new billing address for this card.',
    ACCOUNT_BILLING_ADD_CC_ADDRESS: 'New Billing Address',
    ACCOUNT_BILLING_ADD_CC_CC_CVV_TT: 'The 3 digit code on the back of card signature line or for Amex the 4 digit code on the front.',
    ACCOUNT_BILLING_ADD_CC_CC_CVV: 'CVV',
    ACCOUNT_BILLING_ADD_CC_CC_EXP_MO_DEFAULT: 'Month',
    ACCOUNT_BILLING_ADD_CC_CC_EXP_TT: 'The expiration month and year of your credit card.',
    ACCOUNT_BILLING_ADD_CC_CC_EXP_YEAR_DEFAULT: 'Year',
    ACCOUNT_BILLING_ADD_CC_CC_EXP: 'Expiration',
    ACCOUNT_BILLING_ADD_CC_CC_NAME_TT: 'Enter a name as an identifier of this card',
    ACCOUNT_BILLING_ADD_CC_CC_NAME: 'Card Nickname',
    ACCOUNT_BILLING_ADD_CC_CC_NUM_TT: 'The full 16 digit number on the front of your credit card.',
    ACCOUNT_BILLING_ADD_CC_CC_NUM: 'Card Number',
    ACCOUNT_BILLING_ADD_CC_COUNTRY_DEFAULT: 'Enter country',
    ACCOUNT_BILLING_ADD_CC_COUNTRY_TT: 'Select the country that your credit card was issued in.',
    ACCOUNT_BILLING_ADD_CC_COUNTRY: 'Country',
    ACCOUNT_BILLING_ADD_CC_CURRENT_ADDRESS_TT: 'The current address on your account. If this is not your billing address, please update your billing address below.',
    ACCOUNT_BILLING_ADD_CC_CURRENT_ADDRESS: 'Account Address',
    ACCOUNT_BILLING_ADD_CC_CUST_NAME_TT: 'Enter customer name exactly as written on the card',
    ACCOUNT_BILLING_ADD_CC_CUST_NAME: 'Name on Card',
    ACCOUNT_BILLING_ADD_CC_HEADER: 'Add Card',
    ACCOUNT_BILLING_ADD_CC_INVALID_MONTH: 'Please enter a valid expiration month.',
    ACCOUNT_BILLING_ADD_CC_NEW_ADDRESS_TT: 'Please use the billing address on file with your credit card account.',
    ACCOUNT_BILLING_ADD_CC_NEW_ADDRESS_TWO_DEFAULT: 'Optional',
    ACCOUNT_BILLING_ADD_CC_NEW_ADDRESS: 'Billing Address',
    ACCOUNT_BILLING_ADD_CC_NEW_CITY_TT: 'The city associated with your credit card billing address.',
    ACCOUNT_BILLING_ADD_CC_NEW_CITY: 'City',
    ACCOUNT_BILLING_ADD_CC_NEW_POSTAL_CODE_TT: 'The postal code associated with your credit card billing address.',
    ACCOUNT_BILLING_ADD_CC_NEW_POSTAL_CODE: 'Zip/Postal Code',
    ACCOUNT_BILLING_ADD_CC_NEW_REGION_DEFAULT: 'Select',
    ACCOUNT_BILLING_ADD_CC_NEW_REGION_TT: 'The region associated with your credit card billing address.',
    ACCOUNT_BILLING_ADD_CC_NEW_REGION: 'State/Region',
    ACCOUNT_BILLING_ADD_CC_NEW_STATE_DEFAULT: 'Select',
    ACCOUNT_BILLING_ADD_CC_NEW_STATE_TT: 'The state associated with your credit card billing address.',
    ACCOUNT_BILLING_ADD_CC_NEW_STATE: 'State',
    ACCOUNT_BILLING_ADD_CC_NEW_ZIP_TT: 'The zip code associated with your credit card billing address.',
    ACCOUNT_BILLING_ADD_CC_NEW_ZIP: 'Zip',
    ACCOUNT_BILLING_ADD_CC_SUCCESS: 'New credit card added.',
    ACCOUNT_BILLING_ADD_CC_UPDATE_BUTTON: 'Add Card',
    ACCOUNT_BILLING_CC_ACTIONS: 'Actions',
    ACCOUNT_BILLING_CC_ADD_CARD: 'Add Card',
    ACCOUNT_BILLING_CC_COUNTRY: 'Country',
    ACCOUNT_BILLING_CC_DEFAULT_TT: 'Default Card',
    ACCOUNT_BILLING_CC_DEFAULT: 'Default',
    ACCOUNT_BILLING_CC_EXPIRATION: 'Expiration',
    ACCOUNT_BILLING_CC_HEADER: 'Credit Cards',
    ACCOUNT_BILLING_CC_MAKE_DEFAULT_SUCCESS: ' is your new default card.',
    ACCOUNT_BILLING_CC_MAKE_DEFAULT_TT: 'Make Default',
    ACCOUNT_BILLING_CC_NUMBER: 'Card Number',
    ACCOUNT_BILLING_CC_REMOVE_MODAL_BODY_1: 'Are you sure you want to remove your',
    ACCOUNT_BILLING_CC_REMOVE_MODAL_BODY_2: 'ending in',
    ACCOUNT_BILLING_CC_REMOVE_MODAL_CANCEL: 'Cancel',
    ACCOUNT_BILLING_CC_REMOVE_MODAL_HEADER: 'Remove Credit Card',
    ACCOUNT_BILLING_CC_REMOVE_MODAL_YES: 'Remove',
    ACCOUNT_BILLING_CC_REMOVE_SUCCESS: 'Credit Card removed.',
    ACCOUNT_BILLING_CC_REMOVE_TT: 'Remove',
    ACCOUNT_BILLING_CC_STATUS: 'Status',
    ACCOUNT_BILLING_LAST_FAILED: 'Last Failed Attempt',
    ACCOUNT_BILLING_CC_TYPE_AMEX_TT: 'American Express',
    ACCOUNT_BILLING_CC_TYPE_DISCOVER_TT: 'Discover',
    ACCOUNT_BILLING_CC_TYPE_MASTERCARD_TT: 'MasterCard',
    ACCOUNT_BILLING_CC_TYPE_VISA_TT: 'Visa',
    ACCOUNT_BILLING_CC_TYPE: 'Type',
    ACCOUNT_BILLING_CC_VERIFIED: 'Verified',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_HEADER: 'Verify Credit Card',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_MAX_FILE_SIZE_ERROR: 'File must be less than 7 MB, please select another file.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_FILE_ERROR: 'Invalid file, please try another file.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_BACK_TT: 'Upload a picture or scan of the back of this credit card.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_BACK: 'Upload Card Back',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_EXAMPLE: 'Please {instruction} of your credit card as pictured in the example below.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_EXAMPLE_INSTRUCTION: 'block out all but the last 4 digits',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT_TT: 'Upload a picture or scan of the front of this credit card. Please make sure only the last 4 digits are visible.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_FRONT: 'Upload Card Front',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_ID_TT: 'Upload a picture or scan of your government issued identification.',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_UPLOAD_CARD_ID: 'Upload ID',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_VERIFY_BUTTON: 'Verify',
    ACCOUNT_BILLING_CC_VERIFY_MODAL_VERIFY_SUCCESSFUL_MESSAGE: 'The files have been uploaded successfully and will be reviewed within 72 hours.',
    ACCOUNT_BILLING_CC_VERIFY_TT: 'Verify Card',
    ACCOUNT_BILLING_CC_EMPTY: 'There are no credit cards to display.',
    ACCOUNT_BILLING_PLAN_HEADER: 'Ringba Plan',
    ACCOUNT_BILLING_PLAN_CURRENT_TT: 'Select your Ringba billing plan',
    ACCOUNT_BILLING_PLAN_CURRENT: 'Current Plan',
    ACCOUNT_BILLING_VIEW_PRICING_BUTTON: 'View Current Pricing',
    ACCOUNT_BILLING_PLAN_MONTHLY_FEE: 'Platform Fee',
    ACCOUNT_BILLING_PLAN_MONTHLY_FEE_TT: 'The fee charged for access to Ringba.',
    ACCOUNT_BILLING_SCHEDULE_ANNUALLY: 'Annually',
    ACCOUNT_BILLING_SCHEDULE_MONTHLY: 'Monthly',
    NEXT_CHARGE_DATE: 'Next Charge',
    NEXT_CHARGE_DATE_TT: 'The date the next charge will happen to renew the billing plan cycle',
    CURRENT_PRICING: 'Current Pricing',
    ACCOUNT_BILLING_RECORDING_PRICING: 'Recording Pricing:',
    ACCOUNT_BILLING_RECORDING_MINUTE: 'Minute',
    ACCOUNT_BILLING_ICP_PRICING: 'Instant Caller Profile (ICP) Pricing:',
    ACCOUNT_BILLING_ICP_REQUEST: 'Request',
    ACCOUNT_BILLING_TRANSCRIPTION_PRICING: 'Transcription Pricing:',
    ACCOUNT_BILLING_TRANSCRIPTION_MINUTE: 'Minute',
    ACCOUNT_BILLING_VOICE_AGENTS_PRICING: 'Voice Agents Pricing:',
    ACCOUNT_BILLING_VOICE_AGENTS_MINUTE: 'Minute',
    ACCOUNT_BILLING_CURRENT_PRICING_MODAL_HEADER: 'Your Pricing',
  }
};